import $ from 'jquery';
import 'jquery-mask-plugin';

// Agora você pode usar o jQuery com o alias '$'
$(document).ready(function() {

    var SPMaskBehavior = function (val) {
        return val.replace(/\D/g, '').length === 11 ? '(00) 00000-0000' : '(00) 0000-00009';
    }, spOptions = {
        onKeyPress: function (val, e, field, options) {
            field.mask(SPMaskBehavior.apply({}, arguments), options);

        },
        placeholder: "(00) 0000-0000"
    };

    $('.cellphone').mask(SPMaskBehavior, spOptions);

    var CpfCnpjMaskBehavior = function (val) {
        return val.replace(/\D/g, '').length <= 11 ? '000.000.000-009' : '00.000.000/0000-00';
    },
    cpfCnpjpOptions = {
        onKeyPress: function(val, e, field, options) {
        field.mask(CpfCnpjMaskBehavior.apply({}, arguments), options);
    }
    };

    $(function() {
    $('.cpfCnpj').mask(CpfCnpjMaskBehavior, cpfCnpjpOptions);
    })

    /// itens de pedido
    $('.cep').mask("00.000-000", { placeholder: "00.000-000" });
    $('.rg').mask("000000000000000");
    $('.cardCvv').mask("0000");
    $('.cardNumber').mask("0000 0000 0000 0000");
    $('.cardNumber').on('change', function(){
        if($(this).val().length != 19){
            alert('O número precisa obedecer o formato 0000 0000 0000 0000');
            $(this).val('');
            $(this).focus();
        }
    });

    $('.cardMonth').mask("00");
    $(".cardMonth").on('change', function(){
        if($(this).val().length < 2){
            alert('O mês precisa ter dois dígitos de 01 a 12');
            $(this).val('');
            $(this).focus();
        }else{
            if(($(this).val() < 1) || ($(this).val() > 12)){
                alert('O mês precisa ser válido');
                $(this).val('');
                $(this).focus();
            }
        }
    });

    $('.cardYear').mask("0000");
    $(".cardYear").on('change', function(){
        let year = new Date().getFullYear();
        if($(this).val().length < 4){
            alert('O ano precisa ter quatro dígitos');
            $(this).val('');
            $(this).focus();
        }else{
            if(($(this).val() < year)){
                alert('O ano precisa ser um ano válido');
                $(this).val('');
                $(this).focus();
            }
        }

    });



    $('.year').mask("0000");
    $('.twodigits').mask("00");
    $('.threedigits').mask("000");
    $('.moneyReal').mask("#.##0,00", {reverse: true , placeholder: "R$ "});

    $('.cpf').mask('000.000.000-00', { reverse: true });

    $("input[name=cep]").on('blur',function(){
        var cep = $(this).val().replace(/[^0-9]/, '');
        var data_class = $(this).attr('data-class');
//        console.log(data_class);
		if(cep){
			var url = 'https://viacep.com.br/ws/'+ cep + '/json/' ;
			$.ajax({
                    url: url,
                    dataType: 'jsonp',
                    crossDomain: true,
                    contentType: "application/json",
                    success: function(json) {
                        if (!json.erro) {
                            $("input[name=logradouro]").val(json.logradouro);
                            $("input[name=bairro]").val(json.bairro);
                            $("input[name=localidade]").val(json.localidade);
                            $("input[name=uf]").val(json.uf);
                            $("input[name=numero]").focus();
						}else{
                            $("input[name=logradouro]").val('');
                            $("input[name=bairro]").val('');
                            $("input[name=localidade]").val('');
                            $("input[name=uf]").val('');
                            $("input[name=numero]").val('');
                            $("input[name=cep]").focus();

                            $(document).Toasts('create', {
                                class: 'bg-danger',
                                title: 'Atenção',
                                subtitle: 'Erro',
                                body: 'Cliente <strong>CEP Não existe</strong>',
                                autohide:true,
                                close: false,
                            });
                        }
					}
			});
		}


    });

     $("input[name=social_name]").on("input", function () {
        this.value = this.value
            .replace(/[^\p{L}\s'’-]/gu, '')
            .replace(/\s{2,}/g, ' ')
            .toLocaleUpperCase('pt-BR');
    });


    // init responses
    $("[name*='question'].mix").filter(function() {

        if(this.checked){
            var name = this.name.split('_');
            if(this.value == 0){
                $("[name*='response_"+name[1]+"']").css("display","none");
                $("[name*='response_"+name[1]+"']").attr("disabled", true);
                $("[name*='response_"+name[1]+"']").val("");
            }else{
                $("[name*='response_"+name[1]+"']").css("display","block");
                $("[name*='response_"+name[1]+"']").attr("disabled", false);
            }
        }
    });



    $(".mix").on('change',function(){
        var name = this.name.split('_');
        if(this.value == 0){
            $("[name*='response_"+name[1]+"']").css("display","none");
            $("[name*='response_"+name[1]+"']").attr("disabled", true);
            $("[name*='response_"+name[1]+"']").val("");
        }else{
            $("[name*='response_"+name[1]+"']").css("display","block");
            $("[name*='response_"+name[1]+"']").attr("disabled", false);
        }
    });

});

